import { influencerItems } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function InfluencerSection() {
  return (
    <section id="influencers" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="CREATORS · 网红黑料"
          title="网红黑料专区 · 内容创作的真与假"
          desc="从剧本化运营到选品口碑，网红圈的争议几乎都围绕「真实」二字。以下为公开讨论整理，账号名称均为化名，仅供参考。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {influencerItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-400 transition-colors"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 黑料吃瓜网`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-black/60 text-background-50 text-[11px] font-label">
                  {item.platform}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center justify-between gap-3 mb-2">
                  <span className="font-heading text-base md:text-lg text-foreground-950 truncate">{item.name}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-label shrink-0">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {item.heat}
                  </span>
                </div>
                <h3 className="text-sm md:text-base text-foreground-900 leading-snug mb-2 font-body">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body line-clamp-3">
                  {item.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-auto pt-4">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-accent-50 text-accent-800 text-[11px] font-label"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}